/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {//dar manutenção depois
  title: 'dark',

  colors: {
    primary: '#333',
    secundary: '#ea4335',
    aside: '#333',

    background: '#222',
    text: '#fff',
    textarea:'#333',
    code: '#333',
    img: 'grayscale(1%) brightness(90%) sepia(1) saturate(20%) invert(5)',
  },

};

